module.exports = [{"title":"Activity Booklet","image":"score_2.jpg","manifest":"http://media.getty.edu/data/iiif/publications/books/scores/980063b24f9/manifest.json"},{"title":"Program","image":"score_1.jpg","manifest":""}]


//////////////////
// WEBPACK FOOTER
// ./src/assets/data/kaprow/score.yml
// module id = trna
// module chunks = 0